import { useLocation, useOutletContext } from "react-router-dom";
import PageTitle from "@/components/PageTitle";
import { JobsOutletContext } from "@/pages/_layouts/jobs/JobPostIndexLayout";
import ViewJobOutcome from "@/pages/_layouts/jobs/_components/ViewJobOutcome";
import ApplicantsPageSkeleton from "@/pages/_layouts/jobs/_components/ApplicantPageSkeleton";

export default function JobPostOutcome() {
  const location = useLocation();
  const { data, loading, title, refetch } = useOutletContext<JobsOutletContext>();

  if (loading) {
    return <ApplicantsPageSkeleton />;
  }

  if (!data?.jobPost) return null;

  return (
    <>
      <PageTitle pattern={location.pathname} title={`${title} | Job Post Outcome`} />
      <ViewJobOutcome jobPost={data.jobPost} refetch={refetch} />
    </>
  );
}
